import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AsyncComputed from 'vue-async-computed'
import DeviceDetect from './mixins/DeviceDetect'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import i18n from './i18n'
import VCalendar from 'v-calendar'
import VueSocialSharing from 'vue-social-sharing'
import VueMeta from 'vue-meta'
import { hasSession, ensureSesionRenew } from '@/services/checksession'

console.log('ENV = ' + process?.env?.NODE_ENV)
if (process?.env?.NODE_ENV !== 'development') {
  console.log('Disabling logs')
  window.console.log = () => {}
}

Vue.mixin(DeviceDetect)
Vue.mixin(i18n)
Vue.config.productionTip = false
Vue.use(AsyncComputed)
Vue.use(VModal)
Vue.use(VTooltip)
Vue.use(VueSocialSharing)
Vue.use(VCalendar)
Vue.use(VueMeta)

if(hasSession()) {
	ensureSesionRenew('ca').then(startVue)
} else {
	startVue()
}

function startVue() {
	new Vue({
		router,
		store,
		render: h => h(App),
	}).$mount('#app')	
}


